let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6GplY")).then(() => parcelRequire('9J6zQ'));